module.exports = __webpack_public_path__ + "static/media/stamp-star.73d2360b.svg";